import {Component, OnInit, ViewChild, Inject} from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  AbstractControl,
  Validators,
} from '@angular/forms';
import { OrderService } from '../services/order.service';
import { Country } from '../../dto/country';
import { Company } from '../../dto/company';
import {ClientOrder, Order} from '../../dto/order';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DocsNames } from '../../dto/docs-names';
import { WebIdAction } from '../../dto/web-id-action';
import { CardSelectorComponent } from './card-selector/card-selector.component';
import { SofortPaymentService } from '../services/sofort-payment.service';
import { Router } from '@angular/router';
import { NewSofortTransaction } from '../../dto/new-sofort-transaction';
import {Product, ProductCheckedInfo} from '../../dto/product';
import { environment } from '../../../environments/environment';
import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';

import {FormControl} from '@angular/forms';
import {SofortPaymentModel} from '../../models/sofort-payment-model';
import {PartialOrderRequest} from '../../dto/partial-order-request';
import {PartialOrderResult} from '../../dto/partial-order-result';
import {byNumeric} from 'iso-country-codes';
import {PhoneInputComponent} from './phone-input/phone-input.component';

export class EmailValidation {
  static MatchEmails(ac: AbstractControl) {
    const email1 = ac.get('email').value;
    const email2 = ac.get('confirmEmail').value;

    if (email1 != email2) {
      ac.get('confirmEmail').setErrors({ mismatchPassword: true });
    } else {
      ac.get('confirmEmail').setErrors(null);
    }
  }
}

declare let gtag: Function;
declare let ga: Function;
declare let fbq: Function;
declare let tdconv: Function;
declare let _refersion: any;
declare let _rfsn: any;

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css']
})

export class OrderComponent implements OnInit {
  private ignoreEmailValueUpdates = false;
  public isLoading = true;


  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private sofortPaymentService: SofortPaymentService,
    private formBuilder: FormBuilder,
    private router: Router,

    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe((e: LangChangeEvent) => {
        this.titles = this.titlesMap[e.lang];
        this.links = this.linksMap[e.lang];
        this._currentLanguage = translate.currentLang;

      this.orderService.getNationalitiesByLang(this._currentLanguage).subscribe(data => {
        this.nationalities = data;
      });
      this.orderService.getCountriesbyLang(this._currentLanguage).subscribe(countries => {
        this.countries = countries;
      });

      }
    );
    this._currentLanguage = translate.currentLang;

    // MS 2020-11-11 deactivated this, cancelled
    // this.loadRefersion();


  }

  static LOCALSTORAGE_ORDER_KEY = 'partial_order';
  static LOCALSTORAGE_STEP_KEY = 'partial_order_step';
  partialOrder: Order;
  orderPrice = 0;
  @ViewChild(MatStepper, { static: false }) matStepper: MatStepper;
  @ViewChild(PhoneInputComponent, { static: false }) phoneInput: PhoneInputComponent;
  @ViewChild(CardSelectorComponent, { static: false }) products: CardSelectorComponent;


  stopPollVoucher = false;

  showAppStoreIcon = true;
  showPlayStoreIcon = true;
  appStoreLink = '';
  playStoreLink = '';



  company: Company = null;
  docsNames = DocsNames;
  orderForm: FormGroup;
  companyId;
  companyName: string;
  googleAnalyticsCode: string;
  facebookPixelId: string;
  webIdTransactionSubscription: any;
  webIdAction: WebIdAction = { url: '', approximateDateOfExpiry: null, actionId: '', transactionId: null };
  webIdResponse: any;
  allowedPaymentMethods = {
    creditcard: true,
    sofort: true,
    voucher: true,
    invoice: true,
    cashOnDelivery: true,
    free: false,
  };

  allowedPaymentMethods2 = {
    creditcard: false,
    sofort: false,
    voucher: true,
    invoice: false,
    cashOnDelivery: false,
    free: false,
  };

  public productsData: ProductCheckedInfo[];

  showCompanyInput = false;
  showPaymentType2 = false;
  voucherToPay = null;
  wantNews: boolean;
  countries: Country[] = [];
  nationalities: Country[] = [];
  maxDob = this.getMaxDateOfBirth();
  minDob = this.getMinDateOfBirth();
  summaryPageUserAddressing: any;
  isConfirmed = false;
  titlesMap = {
    de: ['Herr', 'Frau'],
    en: ['Mr', 'Mrs', 'Ms'],
  };

  linksMap = {
    de: [this.docsNames.links.license_agreement.de, this.docsNames.links.terms_and_services.de, this.docsNames.links.king_card_insurance.de, this.docsNames.links.cashback_conditions.de],
    en: [this.docsNames.links.license_agreement.en, this.docsNames.links.terms_and_services.en, this.docsNames.links.king_card_insurance.en, this.docsNames.links.cashback_conditions.en],
  };
  titles = this.titlesMap.en;
  links = this.linksMap.en;
  _currentLanguage;



  private webIdUrl: string;
  private showWebIdInfo: boolean;

  private stripePaymentActive: boolean;
  private hasOrder: boolean;
  private hasInvoice: boolean;
  private orderId: number;
  private invoiceId: number;
  private invoiceNumber: string;
  private partialOrderReference: string;


  selectedProduct: Product = null;
  selectedProductId = -1;

  cartId: string = null;
  isRefersionInit = false;
  refersionIntervall;
  isEmailValid = false;
  isCheckingEmail = false;
  isGrowActive = false;

  orderFormDisabled = false;

  price = null;

  step1completed = false;
  step2completed = false;
  step3completed = false;
  step4completed = false;
  step5completed = false;
  isPhoneVerified = false;

  static loadGrowInitCode(): void {

    const growScript = document.createElement('script');
    growScript.setAttribute('async', 'true');
    growScript.innerText = `(function(i,s,o,g,r,a,m){i['TDConversionObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script', 'https://svht.tradedoubler.com/tr_sdk.js?org=2308356&prog=325100&dr=true&rand=' + Math.random(), 'tdconv');`;
    document.documentElement.firstChild.appendChild(growScript);

    // console.log("inserted");
  }

  /*
  loadGrow(oid, oval, vcode){
    // Grow


    let growScript = document.createElement('script');
    growScript.innerText = `
     <!-- Start TradeDoubler Conversion Tag Insert on confirmation Page -->
<script language="JavaScript">
tdconv('init', '2308356', {'element': 'iframe' });
tdconv('track', 'sale', {'transactionId':'${ oid }', 'ordervalue':${ oval }, 'voucher':'${ vcode }', 'currency':'EUR', 'event':419816});
</script>
<!-- End TradeDoubler tag-->
    `;

    // ${ pixelId }

    //console.log(growScript.innerText);

    document.documentElement.firstChild.appendChild(growScript);


    // /Grow
  }
  */



  static loadGoogleAnalytics(trackingID: string): void {

    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');

    gaScript.innerText = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

      ga('create', '` + trackingID + `', 'auto');  // Replace with your property ID.
      ga('require', 'ec');
      `;

    document.documentElement.firstChild.appendChild(gaScript);

  }


  static loadGoogleTagManager(trackingID: string): void {

    const gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${ trackingID }`);

    const gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${ trackingID }\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  static loadFacebookPixel(pixelId: string): void {

    const fbScript = document.createElement('script');
    fbScript.innerText = `
     !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${ pixelId }');
    `;

    document.documentElement.firstChild.appendChild(fbScript);
  }

  removeFormControlError(control: AbstractControl, errorName: string) {
    if (control.errors && control.errors[errorName]) {
      delete control.errors[errorName];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }

  loadRefersion() {
    // Refersion

    this.cartId = this.makeid(40);

    // console.log(this.cartId);

    const refScript = document.createElement('script');
    refScript.setAttribute('async', 'true');
    refScript.setAttribute('type', 'text/javascript');
    refScript.setAttribute('src', `https://cardcompact.refersion.com/tracker/v3/pub_ce076fff29489a6a32b9.js`);
    document.getElementsByTagName('head')[0].appendChild(refScript);




    // /Refersion
  }





  makeid(length) {

    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  ngOnInit() {

    this.isLoading = true;

    // for testing Grow
    /*
    this.route.queryParams
      .subscribe(params => {

          if ( params != null && params.growIsActive === "1" ) {
            this.isGrowActive = true;
          } else {
            this.isGrowActive = false;
          }

        }
      );
    */

    /*this.refersionIntervall = setTimeout(() => {
      let id = this.cartId;
      if(_refersion && !this.isRefersionInit)
        _refersion(function () {_rfsn._addCart(id)});
    }, 5000);*/



    this.document.body.classList.add('order-assistant');

    const path = this.route.snapshot.paramMap.get('id');
    this.orderService.getCompany(path).subscribe(
      (company: Company) => {

        this.company = company;
        this.companyId = company.id;
        this.companyName = company.name;
        this.googleAnalyticsCode = company.googleAnalyticsCode;
        this.facebookPixelId = company.facebookPixelId;

        // Grow / ONLY KING
        if (environment.production && this.companyId == 1) {
          this.isGrowActive = true;
          OrderComponent.loadGrowInitCode();
        } else {
          // console.log("NO GROW -- " + (this.isGrowActive));
        }

        this.orderService.getProducts(this.companyId).subscribe(data => {
          const fsData = [];
          const checkFirst = data.length === 1;

          this.isLoading = false;

          let isFirst = true;
          data.forEach( product => {

            if ( isFirst) {
              this.appStoreLink = product.appStoreLink;
              this.playStoreLink = product.playStoreLink;
            }

            product.logoUrl = product.logoFileName ? environment.apiUrl + product.logoFileName : null;



            fsData.push({
              ...product,
              checked: isFirst && checkFirst,
            });
            if ( isFirst && checkFirst ) {
              // this.writeValue(product.id);
              // this.onChange(product.id);
              this.selectedProduct = product;
              this.selectedProductId = product.id;

              this.orderPrice = this.selectedProduct.annualFee + this.selectedProduct.issuingFee;


            }

            if (!product.showAppStoreIcon) {
              this.showAppStoreIcon = false;
            }
            if (!product.showPlayStoreIcon) {
              this.showPlayStoreIcon = false;
            }

            isFirst = false;
          });

          this.productsData = fsData;

        });




        this.allowedPaymentMethods = {
          creditcard: company.creditCardPaymentEnabled,
          sofort: company.sofortPaymentEnabled,
          voucher: false,
          invoice: company.invoicePaymentEnabled,
          cashOnDelivery: company.cashOnDeliveryPaymentEnabled,
          free: false
        };

        this.allowedPaymentMethods2 = {
          creditcard: false,
          sofort: false,
          voucher: company.voucherPaymentEnabled,
          invoice: false,
          cashOnDelivery: false,
          free: false
        };

        this.orderService.getNationalitiesByLang(this._currentLanguage).subscribe(data => {
          this.nationalities = data;
        });
        this.orderService.getCountriesbyLang(this._currentLanguage).subscribe(countries => {
            this.countries = countries;
          },
          err => {
            this.showMessage(err.error.message || err.error || err.message);
          });

        this.orderForm = this.formBuilder.group(
          {
            product: this.formBuilder.group({
              productId: '',

            }),

            name: this.formBuilder.group({ /*sex: "",*/
              title: ['', Validators.compose([Validators.required])],
              firstName: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
              lastName: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(20)])],
              companyName: new FormControl('', [this.companyNameValidator]),
              isCompany: false,
              wantCardName: false,
              cardName: [{ value: '', disabled: true }, [Validators.compose([Validators.required, Validators.maxLength(19)])]],
              privacyPolicy: false,
              wantNews: true,
              wantTotalCardInfos: false,




              email: [
                '',
                {
                  validators: Validators.compose([
                    Validators.required,
                    // Validators.email,
                    Validators.pattern('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'),
                    Validators.minLength(7),
                    Validators.maxLength(70)
                  ]),
                  updateOn: 'blur'
                }
              ],
              confirmEmail: ['', Validators.compose([Validators.required, Validators.email])],

            }, {
              validator: EmailValidation.MatchEmails
            }),
            cardName: this.formBuilder.group({ cardName: '' }),
            location: this.formBuilder.group({
              dob: '',
              nationality: 'Germany',
              address: new FormControl('', [this.addressValidator]), // [null, [Validators.pattern(APP_CONSTANTS.ADDRESS_PATTERN)]],
              building:  new FormControl('', [this.buildingValidator]), // [null, [Validators.pattern(APP_CONSTANTS.BUILDING_PATTERN)]],
              zipCode: new FormControl('', [this.zipValidator]), // "",
              city: '',
              countryIsoCode: 276
            }),
            /*dob: this.formBuilder.group(,
              {
                validator: (fg: FormGroup) => {
                  return null;
                }
              }),
            nationality: this.formBuilder.group({  }),*/

            phone: this.formBuilder.group({ phone: '' }),
            paymentType: this.formBuilder.group({
              paymentType: '',
              paymentType2: ''}),
          }
        );


        this.orderForm.controls['product'].valueChanges.subscribe(value => {

          if ( value.productId != null && !this.orderForm.disabled ) {
            this.productsData.forEach(x => {
              if ( x.id == value.productId ) {
                // alert("a");
                this.selectedProduct = x;

              }
            });
          }
        });

        this.orderForm.get('location.countryIsoCode').valueChanges.subscribe(value => {
          this.orderForm.get('location.zipCode').updateValueAndValidity();
        });

        this.orderForm.get('name.email').valueChanges.subscribe(value => {
          if ( this.ignoreEmailValueUpdates ) {
return;
}
          if ( this.selectedProduct ) {
            this.checkEmail();
          }
        });

        this.orderForm.get('name.isCompany').valueChanges.subscribe(value => {

          // console.log(value);

          if (value != null && value) {

            this.showCompanyInput = true;
            this.orderForm.controls['name'].patchValue({
              companyName: ''
            });
          } else {
            this.showCompanyInput = false;
            // console.log("title: "+this.orderForm.value.name.company );
            if ( this.orderForm.value.name.company != null || this.orderForm.value.name.company != '' ) {
              this.orderForm.controls['name'].patchValue({
                companyName: null
              });
            }
          }
        });


        this.orderForm.controls['paymentType'].valueChanges.subscribe(value => {
          // console.log(value);
          if ( this.allowedPaymentMethods2.voucher && value.paymentType2 && value.paymentType2.type == 'VOUCHER' ) {
            if ( value.paymentType2.code ) {


              if ( !this.stopPollVoucher ) {

                this.orderService.validateVoucherWithAmount(value.paymentType2.code, this.orderForm.value.product.productId, this.orderForm.value.name.wantCardName, value.paymentType.type).subscribe(data => {
                  const amountRemaining = data.amountRemaining;
                  if (amountRemaining != null) {
                    const p = amountRemaining;
                    const n = p.toFixed(2);
                    const numFinal = parseFloat(n);

                    // console.log(numFinal);
                    if (numFinal > 0) {
                      this.voucherToPay = numFinal.toFixed(2);
                      this.showPaymentType2 = true;
                    } else {
                      this.voucherToPay = 0.00;
                      this.showPaymentType2 = true;

                      this.allowedPaymentMethods = {
                        creditcard: false,
                        sofort: false,
                        voucher: true,
                        invoice: false,
                        cashOnDelivery: false,
                        free: false,
                      };
                    }
                  }
                }, error => {
                  this.snackBar.open(error.error, null, {
                    duration: 5000,
                    panelClass: ['app-mat-snack-bar']
                  });

                  this.showPaymentType2 = false;

                  // this.orderForm.controls['paymentType'].reset()
                  // this.orderForm.controls['paymentType'].clearValidators();


                });
              }



            } else {
              this.showPaymentType2 = false;
            }
          }

        });


        if ((environment.production) && this.googleAnalyticsCode != null && this.googleAnalyticsCode.length > 0 ) {
          OrderComponent.loadGoogleTagManager(this.googleAnalyticsCode);
        } else {
          console.log('NO GA ' + this.googleAnalyticsCode + ' in ' + (environment.production ? 'PROD' : 'DEV'));
        }



        if ((environment.production) && this.facebookPixelId != null && this.facebookPixelId.length > 0 ) {
          OrderComponent.loadFacebookPixel(this.facebookPixelId);
        } else {
          console.log('NO FacebookPixel ' + this.facebookPixelId + ' in ' + (environment.production ? 'PROD' : 'DEV'));
        }



        setTimeout(() => {

          const o = this.getOrderFromLocalStorage();
          if ( o ) {
            this.orderForm.get('name.title').setValue(o.title);
            this.orderForm.get('name.firstName').setValue(o.firstName);
            this.orderForm.get('name.lastName').setValue(o.lastName);
            this.orderForm.get('name.email').setValue(o.email);
            this.orderForm.get('name.confirmEmail').setValue(o.email);

            this.orderForm.get('location.dob').setValue(o.dob);
            this.orderForm.get('location.city').setValue(o.city);
            this.orderForm.get('location.zipCode').setValue(o.zipCode);
            this.orderForm.get('location.address').setValue(o.addressOnly);
            this.orderForm.get('location.building').setValue(o.building);

            this.orderForm.get('location.nationality').setValue(o.nationality);
            this.orderForm.get('location.countryIsoCode').setValue(o.countryIsoCode);

          }

        }, 1000);


      },
      err => {
        this.showMessage(err.error.message || err.error || err.message);
      });



  }



  getRealPrice() {
    let myProduct = null;
    if ( this.orderForm.value.product ) {
      this.productsData.forEach(p => {
        if ( p.id === this.orderForm.value.product.productId ) {
          myProduct = p;
        }
      });
    }


    const price = myProduct.issuingFee + myProduct.annualFee;

  }

  zipValidator(formControl: AbstractControl) {


    if (!formControl.parent) {
      return null;
    }


    const val = formControl.value;

    if (val[0] == '+') {
      return { notAllowed: true };
    }

    const isoCode = formControl.parent.get('countryIsoCode').value;
    if (isoCode) {

      // DE
      if ( isoCode == 276) {
        const sumDigits = /\b\d{5}\b/;
        if (!sumDigits.test(val)) {
          return { notAllowed: true };
        }
      }
      // AT
      if ( isoCode == 40) {
        const sumDigits = /\b\d{4}\b/;
        if (!sumDigits.test(val)) {
          return { notAllowed: true };
        }
      }

    }

    return null;
  }


  addressValidator(formControl: AbstractControl) {

    const regEx = /^[A-Za-zÀ-ž'\.\-\s]+$/;

    const val = formControl.value;

    if (!regEx.test(val)) {
      return { notAllowed: true };
    }

    if (val[0] == '+' || val[0] == '0') {
      return { notAllowed: true };
    }




    return null;
  }

  buildingValidator(formControl: AbstractControl) {

    const val = formControl.value;

    if (val[0] == '+' || val[0] == '0') {
      return { notAllowed: true };
    }



    const fourDigits = /\d{5}/;
    if (fourDigits.test(val)) {
      // console.log("My string has 4 running numbers");
      return { notAllowed: true };
    }

    return null;
  }

  companyNameValidator(formControl: AbstractControl) {
    // console.log(formControl.parent);
    if (!formControl.parent) {
      return null;
    }

    if (formControl.parent.get('isCompany').value) {

      if ( !formControl.value ) {
        return { required: true };
      }

      if ( formControl.value != null && formControl.value.length < 2 ) {
        return { too_low: true };
      }
      if ( formControl.value != null && formControl.value.length > 100 ) {
        return { too_high: true };
      }
    }

    return null;
  }

  createOrder() {

    if ( this.orderFormDisabled ) {
      return;
    }
    this.orderFormDisabled = true;

    // !!!damage view!!!
    // this.orderForm.disable();


    this.stopPollVoucher = true;
    // alert("disable order form!!!");


    const orderFromForm = this.getOrderFromForm();
    orderFromForm.refersionCartId = this.cartId;

    orderFromForm.partRef = this.partialOrderReference;


    // trim values
    if ( orderFromForm.firstName != null ) {
      orderFromForm.firstName = orderFromForm.firstName.trim();
    }
    if ( orderFromForm.lastName != null ) {
      orderFromForm.lastName = orderFromForm.lastName.trim();
    }
    if ( orderFromForm.email != null ) {
      orderFromForm.email = orderFromForm.email.trim();
    }
    if ( orderFromForm.zipCode != null ) {
      orderFromForm.zipCode = orderFromForm.zipCode.trim();
    }

    this.orderService.createOrder(orderFromForm).subscribe(
      (orderFromBackend: Order) => {

        const orderForm = this.orderForm.getRawValue();
        let myProduct = null;
        if ( orderForm.product ) {
          this.productsData.forEach(p => {
            if ( p.id === orderForm.product.productId ) {
              myProduct = p;
            }
          });
        }

        this.deleteOrderFromLocalStorage();


        // const price = myProduct.issuingFee + myProduct.annualFee;
        const price = this.calcPrice(myProduct, this.orderForm.value.name.wantCardName);

        this.price = price;

        if ( myProduct ) {

          // TODO - create externalref earlier and send to web and use this
          const today = new Date();
          const dd = String(today.getDate()).padStart(2, '0');
          const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
          const yyyy = today.getFullYear();

          const transaction_id = yyyy + '-' + mm + '-' + dd + '.' + Math.floor(Math.random() * 1000) + '.' + orderFromBackend.invoiceNumber;

          const gtag_payload = {

            transaction_id,
            affiliation: 'CardBro',
            value: price,
            currency: 'EUR',
            tax: 0,
            shipping: 0,

            items: [
              {
                id: myProduct.id,
                name: myProduct.name,
                list_name: 'none',
                brand: this.companyName,
                category: 'CC',
                variant: 'Card',
                list_position: 1,
                quantity: 1,
                price,
                currency: 'EUR'
              }
            ], coupon: '' };

          const fbpixel_payload = {
            value: price,
            currency: 'EUR',
            contents: [
              {
                id: myProduct.id,
                quantity: 1
              },
              ],
            content_type: 'product'
          };


          const that = this;
          if (typeof gtag === 'function' || typeof fbq === 'function') {

            if ( typeof gtag === 'function' ) {
              gtag('event', 'purchase', gtag_payload, );
            }

            if ( typeof fbq === 'function' ) {
              fbq('track', 'Purchase', fbpixel_payload);
            }

            if ( this.isGrowActive && typeof tdconv === 'function' ) {

              const grow_payload = {
                transactionId: orderFromBackend.id,
                ordervalue: this.price != null ? this.price : 0,
                voucher: orderFromBackend.voucherCode != null && orderFromBackend.voucherCode != '' ? orderFromBackend.voucherCode : '',
                currency: 'EUR',
                event: 419816
              };

              if (!environment.production) {
                console.log(grow_payload);
              }

              tdconv('init', '2308356', {element: 'iframe' });
              tdconv('track', 'sale', grow_payload);
            }

            setTimeout(function() {
              that.postProcessOrder(orderForm, orderFromForm, orderFromBackend);
            }, 2000);

          } else {
            console.log('not logging gtag or fbq purchase ' + JSON.stringify(gtag_payload) + '----' + JSON.stringify(fbpixel_payload));
            setTimeout(function() {
              that.postProcessOrder(orderForm, orderFromForm, orderFromBackend);
            }, 1000);
          }
        }

      },
      err => {

        this.orderFormDisabled = false;

        this.snackBar.open( err.error.message || err.error || err.message || err, null, {
          duration: 5000,
          panelClass: [ 'app-mat-snack-bar' ]
        } );
      }
    );
  }

  public postProcessOrder(orderForm: any, orderFromForm: Order, orderFromBackend: Order) {
    if ( orderFromBackend.webIdTransaction ) {
      this.webIdUrl = orderFromBackend.webIdTransaction.url;
      this.showWebIdInfo = true;
    }

    this.hasOrder = true;
    this.orderId = orderFromBackend.id;
    this.hasInvoice = true;
    this.invoiceId = orderFromBackend.invoiceId;
    this.invoiceNumber = orderFromBackend.invoiceNumber;



    // console.log(this.orderForm.value.paymentType);
    if (orderForm.paymentType.paymentType.type === 'SOFORT') {
      const spm = new SofortPaymentModel();
      spm.invoiceId = orderFromBackend.invoiceId;
      spm.invoiceCode = null;

      this.sofortPaymentService.initializeSofortPayment(spm).subscribe((newTransaction: NewSofortTransaction) => {
        window.location.href = newTransaction.paymentUrl;
      });
    } else if (orderForm.paymentType.paymentType.type === 'CREDIT_CARD') {
      this.stripePaymentActive = true;

      let paymentUrl = '/payment/' + this.invoiceNumber + '/cc';
      if ( this.webIdUrl ) {
        paymentUrl += '?successUrl=' + encodeURIComponent(this.webIdUrl) + '&abort=' + encodeURIComponent(orderFromBackend.protectedOrderId);
      } else {
        paymentUrl += '?successUrl=' + encodeURIComponent('https://cardcompact.com') + '&abort=' + encodeURIComponent(orderFromBackend.protectedOrderId); // TODO redirect to some page with a summary
      }

      window.location.href = paymentUrl;

    } else {
      if ( orderFromBackend.webIdTransaction && this.showWebIdInfo ) {
        this.redirectToWebId();
      } else {
        this.matStepper.next();
      }

    }
  }

  private saveOrderToLocalStorage(partialOrder: ClientOrder, step: number): void {
    const j = JSON.stringify(partialOrder);
    localStorage.setItem(OrderComponent.LOCALSTORAGE_ORDER_KEY, j);
    localStorage.setItem(OrderComponent.LOCALSTORAGE_STEP_KEY, step.toString());
  }

  private getOrderFromLocalStorage(): ClientOrder|null {
    const s = localStorage.getItem(OrderComponent.LOCALSTORAGE_ORDER_KEY);
    const o = JSON.parse(s) as ClientOrder;
    return o;
  }
  private getStepFromLocalStorage(): number {
    const s = localStorage.getItem(OrderComponent.LOCALSTORAGE_STEP_KEY);
    const st = parseInt(s);
    if ( isNaN(st) ) {
return 0;
}
    return st;
  }

  private deleteOrderFromLocalStorage(): void {
    localStorage.removeItem(OrderComponent.LOCALSTORAGE_ORDER_KEY);
    localStorage.removeItem(OrderComponent.LOCALSTORAGE_STEP_KEY);

  }


  public onStepChange(event: any): void {
    // console.log(event.selectedIndex);
    // console.log(this.selectedProduct);
    let myProduct = null;
    if ( this.orderForm.value.product ) {
      this.productsData.forEach(p => {
        if ( p.id === this.orderForm.value.product.productId ) {
          myProduct = p;

          // MS 2020-11-11, set selectedProduct and -Id
          this.selectedProductId = p.id;
          this.selectedProduct = p;
        }
      });
    }

    const price = this.calcPrice(myProduct, this.orderForm.value.name.wantCardName);

    if ( price == 0 && !this.orderForm.value.name.wantCardName ) {
      this.allowedPaymentMethods = {
        creditcard: false,
        sofort: false,
        voucher: false,
        invoice: false,
        cashOnDelivery: false,
        free: true,
      };
    } else {
      this.allowedPaymentMethods = {
        creditcard: this.company.creditCardPaymentEnabled,
        sofort: this.company.sofortPaymentEnabled,
        voucher: false, // this.company.voucherPaymentEnabled,
        invoice: this.company.invoicePaymentEnabled,
        cashOnDelivery: this.company.cashOnDeliveryPaymentEnabled,
        free: false
      };

      this.allowedPaymentMethods2 = {
        creditcard: false,
        sofort: false,
        voucher: this.company.voucherPaymentEnabled,
        invoice: false,
        cashOnDelivery: false,
        free: false
      };
    }


    if ( event.selectedIndex === 1 ) {
      this.checkEmail();

      if ( myProduct ) {
        const gtag_payload = {
          items: [
            {
              id: myProduct.id,
              name: myProduct.name,
              list_name: 'none',
              brand: this.companyName,
              category: 'CC',
              variant: 'Card',
              list_position: 1,
              quantity: 1,
              price,
              currency: 'EUR'
            }
          ], coupon: '' };

        if (typeof gtag === 'function') {
          gtag('event', 'begin_checkout', gtag_payload, );

        } else {
          console.log('not logging gtag begin_checkout ' + JSON.stringify(gtag_payload));
        }
      }

    }

    const gtag_payload = {
      items: [
        {
          id: myProduct.id,
          name: myProduct.name,
          list_name: 'none',
          brand: this.companyName,
          category: 'CC',
          variant: 'Card',
          list_position: 1,
          quantity: 1,
          price,
          currency: 'EUR'
        }
      ],
      coupon: '',
      checkout_step: event.selectedIndex
    };

    if (typeof gtag === 'function') {
      gtag('event', 'checkout_progress', gtag_payload);
    } else {
      console.log('not logging gtag checkout_progress ' + JSON.stringify(gtag_payload));
    }

    if ( event.selectedIndex > 1 ) {
      this.partialOrder = this.getOrderFromForm();

      this.orderPrice = this.selectedProduct.annualFee + this.selectedProduct.issuingFee;


      // workaround
      this.partialOrder.countryName = byNumeric[this.partialOrder.countryIsoCode.toString().padStart(3, '0')].alpha3;

      const partialOrderRequest = new PartialOrderRequest();
      partialOrderRequest.order = this.partialOrder;
      partialOrderRequest.step = event.selectedIndex;
      partialOrderRequest.partRef = this.partialOrderReference || '';

      const partialOrder = this.partialOrder;


      // trim values
      if ( partialOrder.firstName != null ) {
        partialOrder.firstName = partialOrder.firstName.trim();
      }
      if ( partialOrder.lastName != null ) {
        partialOrder.lastName = partialOrder.lastName.trim();
      }
      if ( partialOrder.email != null ) {
        partialOrder.email = partialOrder.email.trim();
      }
      if ( partialOrder.zipCode != null ) {
        partialOrder.zipCode = partialOrder.zipCode.trim();
      }


      this.orderService.updatePartialOrder(partialOrderRequest).subscribe((partialOrderResult: PartialOrderResult) => {
        this.partialOrderReference = partialOrderResult.partRef;
      });

      const co = partialOrder as ClientOrder;
      co.building = this.orderForm.get('location.building').value;
      co.addressOnly = this.orderForm.get('location.address').value;
      co.smsConfirmationCode = null;
      this.saveOrderToLocalStorage(co, event.selectedIndex);

    }



  }



  showMessage(msg) {
    this.snackBar.open(msg, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }

  getMaxDateOfBirth() {
    // This is used to prevent persons under 18 years from creating orders
    // There is an additional control in the API, consider it when changing the minimal person age.
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    maxDate.setHours(0, 0, 0, 0);
    return maxDate;
  }

  getMinDateOfBirth() {
    // MS
    // This is used to prevent persons from entering birth dates that are over 100 years ago
    // There is an additional control in the API, consider it when changing the maximum person age.
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
    minDate.setHours(0, 0, 0, 0);
    return minDate;
  }

  getOrderFromForm() {
    const form = this.orderForm.getRawValue();
    this.summaryPageUserAddressing = {
      title: form.name.title,
      firstName: form.name.firstName,
      lastName: form.name.lastName,
    };


    const o =  {
      productId: form.product.productId,
      title: form.name.title,
      sex: (form.name.title == 'Herr' ? 'Männlich' : form.name.title == 'Frau' ? 'Weiblich' : form.name.title == 'Mr' ? 'Male' : 'Female'),
      firstName: form.name.firstName,
      lastName: form.name.lastName,
      cardName: form.name.wantCardName ? form.name.cardName : '',
      address: form.location.address + ' ' + form.location.building,
      city: form.location.city,
      countryIsoCode: form.location.countryIsoCode,
      zipCode: form.location.zipCode,
      dob: form.location.dob,
      nationality: form.location.nationality,
      email: form.name.email,
      phone: form.phone.phone && form.phone.phone.number,
      smsConfirmationCode: form.phone.phone && form.phone.phone.confirmationCode,
      voucherCode: form.paymentType.paymentType2 && form.paymentType.paymentType2.code != '' ? form.paymentType.paymentType2.code : null ,
      subscribeToNews: form.name.wantNews.toString(),
      language: this._currentLanguage,
      paymentType: form.paymentType.paymentType && form.paymentType.paymentType.type,
      customerCompanyName: form.name.isCompany ? form.name.companyName : null,
      wantTotalCardInfos: form.name.wantTotalCardInfos,

    } as Order;

    if ( this._currentLanguage === 'de' ) {
      o.orderLanguage = 0;
    } else { // english
      o.orderLanguage = 1;
    }

    return o;
  }
  nextStep(stepper) {
    stepper.next();
  }




  redirectToWebId() {
    // window.location.href = this.webIdUrl;
    window.top.location.href = this.webIdUrl;
  }

  private calcPrice(myProduct: Product, wantCardName: boolean): number {
    let price = myProduct.issuingFee + myProduct.annualFee;
    if ( wantCardName ) {
      price += 5;
    }

    return price;
  }

  private checkEmail() {
    this.isCheckingEmail = true;

    const control = this.orderForm.get('name.email');
    this.removeFormControlError(control, 'serverError');
    this.isEmailValid = false;
    this.isCheckingEmail = true;

    const value = control.value;
    if ( value == null || value.trim() == '') {
      this.isCheckingEmail = false;
      this.orderForm.controls['email'].patchValue({
        confirmEmail: ''
      });
      this.ignoreEmailValueUpdates = true;
      control.updateValueAndValidity();
      this.ignoreEmailValueUpdates = false;
      return;
    }

    this.orderService.validateEmail(this.selectedProduct.id, value).subscribe(data => {
      const ok = data.status === 0;
      this.ignoreEmailValueUpdates = true;
      if (!ok) {
        control.setErrors({
          serverError: 'email_invalid',
        });
        this.orderForm.controls['name'].patchValue({
          email: '',
          confirmEmail: ''
        });
        this.orderForm.controls['name'].patchValue({
          email: value,
          confirmEmail: ''
        });
        control.markAsTouched();

      } else {
        this.removeFormControlError(control, 'serverError');
        this.isEmailValid = true;
      }
      this.isCheckingEmail = false;

      control.updateValueAndValidity();

      this.ignoreEmailValueUpdates = false;

    });

  }

  correctDataClicked() {
    this.matStepper.selectedIndex = 1;

    this.step2completed = false;
    this.step3completed = false;
    this.step4completed = false;
    this.step5completed = false;

    this.phoneInput?.resetControl();
    this.isPhoneVerified = false;
  }
}
